exports = module.exports = require("../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "\n.empty-state[data-v-4b4af42c] {\n    max-width: 500px;\n    text-align: center;\n    margin: auto;\n}\n.empty-state p[data-v-4b4af42c] {\n    color: #111 !important;\n}\n.empty-state-icon[data-v-4b4af42c] {\n    font-size: 160px;\n    color: #333 !important;\n}\n", ""]);

